export class UserSession {
    profileId: string
    clientId: number
    profileType: number
    cardNumber: string
    trackingNo: string
    idOrPassportNumber: string
    mobile: string
    email: string
    cardholderName: string
    initalsName: string
    cardID: string
    authToken: string
    cvvNo?: string
    expiryDate?: string
}